<template>
    <div class="relative overflow-x-hidden">
        <jet-authentication-card>
            <template #logo>
                <jet-authentication-card-logo />
            </template>

            <div class="mb-4 text-sm text-iron-600">
                {{ $t("auth.forgot_password.description") }}
            </div>

            <div v-if="status" class="mb-4 text-sm font-medium text-green-600">
                {{ status }}
            </div>

            <jet-validation-errors class="mb-4" />

            <form @submit.prevent="submit">
                <div>
                    <jet-label
                        for="email"
                        :value="$t('auth.forgot_password.email')"
                    />
                    <jet-input
                        id="email"
                        v-model="form.email"
                        type="email"
                        class="mt-1 block w-full"
                        required
                        autofocus
                    />
                </div>

                <div class="mt-4 flex items-center justify-end">
                    <Button type="submit" :disabled="form.processing">
                        {{ $t("auth.forgot_password.send_reset_link") }}
                    </Button>
                </div>
            </form>
        </jet-authentication-card>
    </div>
</template>

<script lang="ts" setup>
import { useForm } from "@inertiajs/vue3";
import JetAuthenticationCard from "../../Jetstream/AuthenticationCard.vue";
import JetAuthenticationCardLogo from "../../Jetstream/AuthenticationCardLogo.vue";
import JetInput from "../../Jetstream/Input.vue";
import JetLabel from "../../Jetstream/Label.vue";
import JetValidationErrors from "../../Jetstream/ValidationErrors.vue";
import route from "ziggy-js";
import { Button } from "@/components/ui/button";

defineProps<{
    status: string;
}>();

const form = useForm({
    email: "",
});

function submit() {
    form.post(route("password.email"));
}
</script>
